function attachTrackpadScroll(sliderEl, flkty) {
  if (!sliderEl || !flkty || sliderEl._trackpadScrollAttached) return;
  sliderEl._trackpadScrollAttached = true;

  var MIN_GESTURE_DELTA = 25;
  var GESTURE_SILENCE = 120;

  var gestureDelta = 0;
  var gestureHandled = false;
  var silenceTimer = null;

  var target = sliderEl.querySelector('.flickity-viewport') || sliderEl;

  target.addEventListener(
    'wheel',
    function(e) {
      var absX = Math.abs(e.deltaX);
      var absY = Math.abs(e.deltaY);

      if (absX <= absY || absX < 1) return;

      e.preventDefault();

      gestureDelta += e.deltaX;

      if (!gestureHandled && Math.abs(gestureDelta) >= MIN_GESTURE_DELTA) {
        gestureHandled = true;

        if (gestureDelta > 0) {
          flkty.next();
        } else {
          flkty.previous();
        }
      }

      clearTimeout(silenceTimer);
      silenceTimer = setTimeout(function() {
        gestureDelta = 0;
        gestureHandled = false;
      }, GESTURE_SILENCE);
    },
    { passive: false }
  );
}

function initShopTheLookSleepSection(sectionEl) {
  if (!sectionEl) return;

  var mobileToggleButtons = sectionEl.querySelectorAll('[data-sleep-mobile-toggle]');

  mobileToggleButtons.forEach(function(button) {
    var textSpan = button.querySelector('.shop-the-look-sleep__mobile-toggle-text');
    var defaultLabel =
      button.getAttribute('data-label-default') ||
      (textSpan ? textSpan.textContent : button.textContent);
    var activeLabel = button.getAttribute('data-label-active') || defaultLabel;

    button.addEventListener('click', function() {
      var targetId = button.getAttribute('data-sleep-mobile-toggle');
      if (!targetId) return;

      var sliderEl = document.getElementById(targetId);
      if (!sliderEl) return;

      var container = sliderEl.closest('.shop-the-look-sleep__mobile-slider-container');
      if (!container) return;

      var isOpen = container.classList.toggle('is-open');

      if (isOpen) {
        button.classList.add('is-active');
        if (activeLabel && textSpan) textSpan.textContent = activeLabel;

        var flkty = Flickity.data(sliderEl);
        if (!flkty) {
          flkty = new Flickity(sliderEl, {
            wrapAround: false,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            cellSelector: '.shop-the-look-sleep__mobile-item',
            adaptiveHeight: false,
          });
          attachTrackpadScroll(sliderEl, flkty);
        } else {
          flkty.resize();
        }
      } else {
        button.classList.remove('is-active');
        if (defaultLabel && textSpan) textSpan.textContent = defaultLabel;
      }
    });
  });

  function adjustSleepHotspotBubble(hotspot) {
    if (!hotspot) return;
    var bubble = hotspot.querySelector('.thb-hotspot-bubble');
    if (!bubble) return;

    bubble.classList.remove('thb-hotspot-bubble--left', 'thb-hotspot-bubble--bottom');

    requestAnimationFrame(function() {
      var rect = bubble.getBoundingClientRect();
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      var margin = 16;

      var needsLeft = rect.right > viewportWidth - margin;
      var needsRight = rect.left < margin;

      if (needsLeft && !needsRight) {
        bubble.classList.add('thb-hotspot-bubble--left');

        var rectAfterLeft = bubble.getBoundingClientRect();
        if (rectAfterLeft.left < margin) {
          bubble.classList.remove('thb-hotspot-bubble--left');
          bubble.classList.add('thb-hotspot-bubble--bottom');
        }
      } else if (needsLeft && needsRight) {
        bubble.classList.add('thb-hotspot-bubble--bottom');
      } else if (!needsLeft && needsRight) {
        bubble.classList.add('thb-hotspot-bubble--bottom');
      }
    });
  }

  var sleepHotspots = sectionEl.querySelectorAll('.thb-hotspot');

  function positionAllSleepBubbles() {
    sleepHotspots.forEach(adjustSleepHotspotBubble);
  }

  if (sleepHotspots.length) {
    positionAllSleepBubbles();
    window.addEventListener('resize', positionAllSleepBubbles);
    window.addEventListener('load', positionAllSleepBubbles);

    sleepHotspots.forEach(function(hotspot) {
      hotspot.addEventListener('mouseenter', function() {
        adjustSleepHotspotBubble(hotspot);
      });

      hotspot.addEventListener('focusin', function() {
        adjustSleepHotspotBubble(hotspot);
      });
    });
  }
}

function initShopTheLookSleep() {
  var sections = document.querySelectorAll('shop-the-look-sleep');
  if (!sections.length) return;

  sections.forEach(initShopTheLookSleepSection);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initShopTheLookSleep);
} else {
  initShopTheLookSleep();
}
